import { AuthType } from '../types';

export const getAuthenticationProvider = (): AuthType => {
	// Auth0 has been removed; Forge is the only supported provider.
	return AuthType.Forge;
};
